import { render, staticRenderFns } from "./mp3Play.vue?vue&type=template&id=3d437f8c"
import script from "./mp3Play.vue?vue&type=script&lang=js"
export * from "./mp3Play.vue?vue&type=script&lang=js"
import style0 from "./mp3Play.vue?vue&type=style&index=0&id=3d437f8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports